import React, { useState } from 'react';
import '../css/Profile.css';
import img from '../assets/rinat.jpg';
import linkedin from '../assets/linkedin.png';
import github from '../assets/github.png';
import resume from '../assets/resume.png';
import shades from '../assets/shades.png';
import resumePDF from '../assets/resume.pdf';

const Profile = () => { 
  const [hide, setHide] = useState(true);

  const handleToggle = () => {
    setHide(!hide);
  }

  return (
      <div className="profile">
        <div className="img-wrapper" onMouseEnter={handleToggle} onMouseLeave={handleToggle}>
          <img src={img} alt="me" />
          <img id="shades" className={hide ? "hide" : "show"} src={shades} alt={"shades"} />
        </div>
        <div className="social">
          <a href="https://www.linkedin.com/in/rinat-tregerman" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt={linkedin} /></a>
          <a href="https://github.com/RinatTr" target="_blank" rel="noopener noreferrer"><img src={github} alt={"github"} /></a>
          <a href={resumePDF} target="_blank" rel="noopener noreferrer"><img src={resume} alt={"resume"} /></a>
        </div>
      </div>
  )

}

export default Profile;
